import { render } from "./cokie_page.vue?vue&type=template&id=8d013870&scoped=true"
const script = {}

import "./cokie_page.vue?vue&type=style&index=0&id=8d013870&lang=stylus&scoped=true"

import exportComponent from "/Volumes/KINDSTON/Lokal Google Drive/PROJECT/TECHSS/techss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d013870"]])

export default __exports__